const TableHead = ({ children }) => {
  return <thead>{children}</thead>;
};

export default TableHead;
